<template>
  <el-dialog :fullscreen="true" v-model="dialogShow" title="审批详情">
    <div class="col">
      <div style="text-align: left">
        <div>
          <span style="margin-right: 10px; color: #5a5c69">提交时间:</span
          ><span style="color: #4668c9">{{
            new Date(currentApprove.createDate).Format("yyyy-MM-dd HH:mm:ss")
          }}</span>
        </div>
        <div>
          <span style="margin-right: 10px; color: #5a5c69">提交用户:</span
          ><span style="color: #4668c9">{{ currentApprove.createUser }}</span>
        </div>
        <div>
          <span style="margin-right: 10px; color: #5a5c69">审批状态:</span>
          <span style="color: #4668c9" v-if="currentApprove.isApproved == null"
            >未审批</span
          >
          <span style="color: green" v-if="currentApprove.isApproved">已通过</span>
          <span style="color: red" v-if="currentApprove.isApproved == false">已拒绝</span>
        </div>
        <div v-if="currentApprove.isApproved != null">
          <span style="margin-right: 10px; color: #5a5c69">审批时间:</span
          ><span style="color: #4668c9">
            {{ new Date(currentApprove.approvedDate).Format("yyyy-MM-dd HH:mm:ss") }}
          </span>
        </div>
        <div>
          <span
            v-if="currentApprove.isApproved != null"
            style="margin-right: 10px; color: #5a5c69"
            >审批用户:</span
          ><span style="color: #4668c9">{{ currentApprove.approvedUser }}</span>
        </div>
        <div>
          <span style="margin-right: 10px; color: #5a5c69">审批简介:</span
          ><span style="color: #4668c9">{{ currentApprove.title }}</span>
        </div>
        <div>
          <span style="margin-right: 10px; color: #5a5c69">修改内容:</span>

          <table>
            <td>修改属性:</td>
            <td style="max-width: 400px">修改前:</td>
            <td style="max-width: 400px">修改后:</td>
            <tr v-for="item in JSON.parse(currentApprove.diffs)" :key="item.index">
              <td :style="item.valB != null ? 'color:red' : 'color:black'">
                {{ item.Prop }}
              </td>
              <td
                style="max-width: 400px"
                v-if="item.Prop == '产品简介'"
                v-html="item.valA"
              ></td>
              <td
                style="max-width: 400px"
                v-if="item.Prop != '产品简介' && item.Prop != '图片'"
              >
                {{ item.valA }}
              </td>
              <td
                style="max-width: 400px"
                v-if="item.Prop != '产品简介' && item.Prop != '图片'"
              >
                {{ item.valB != null ? item.valB : item.valA }}
              </td>
              <td
                style="max-width: 400px"
                v-if="item.Prop == '产品简介'"
                v-html="item.valB == null ? item.valA : item.valB"
              ></td>
              <td style="max-width: 400px" v-if="item.Prop == '图片'">
                <img
                  style="max-height: 150px; max-width: 400px"
                  :src="imagePath + item.valA"
                  alt=""
                />
              </td>
              <td style="max-width: 400px" v-if="item.Prop == '图片'">
                <img
                  v-if="item.valB != null"
                  style="max-height: 150px; max-width: 400px"
                  :src="imagePath + item.valB"
                  alt=""
                />
                <img
                  v-if="item.valB == null"
                  style="max-height: 150px; max-width: 400px"
                  :src="imagePath + item.valA"
                  alt=""
                />
              </td>
            </tr>
          </table>
          <div v-if="currentApprove.isApproved == false">
            <span style="margin-right: 10px; color: #5a5c69; vertical-align: top" 
              >拒绝理由:</span
            >
            <span>
              <pre style="color: red; display: inline-block; font-size: 18px">{{
                currentApprove.refusedMessage
              }}</pre>
            </span>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>

  <el-dialog v-model="RefusedInputShow">
    <el-form-item label="拒绝理由">
      <el-input v-model="RefusedMessage" type="textarea" :rows="3"> </el-input>
      <el-row style="margin-top: 30px" :gutter="10">
        <el-col :span="9"></el-col>
        <el-col :span="2">
          <el-button @click="confirmRefused" type="primary">确定</el-button>
        </el-col>
        <el-col :span="4">
          <el-button
            @click="
              RefusedInputShow = false;
              RefusedMessage = null;
            "
            >取消</el-button
          >
        </el-col>
      </el-row>
    </el-form-item>
  </el-dialog>

  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="card shadow mb-4">
          <div class="card-header py-3">
            <h6 class="text-primary fw-bold m-0"> {{$t('approve')}}</h6>
          </div>
          <ul class="list-group list-group-flush">
            <li
              style="cursor: pointer"
              v-for="item in Approves"
              :key="item.index"
              class="list-group-item"
              @click="showdialog(item)"
            >
              <div class="row align-items-center no-gutters">
                <div class="col-xxl-8 me-2">
                  <h6 class="mb-0">
                    <strong>{{ item.title }}</strong>
                  </h6>
                  <div style="text-align: left" class="text-xs">
                    {{ new Date(item.createDate).Format("yyyy-MM-dd HH:mm:ss") }}
                  </div>
                </div>
                <div style="color: green" v-if="item.isApproved" class="col"> {{$t('passed')}}</div>
                <div style="color: red" v-if="item.isApproved === false" class="col">
                   {{$t('reject')}}
                </div>
                <div v-if="item.isApproved === null" class="col">
                  <button
                    @click.stop="submitClick(item.id)"
                    class="btn btn-primary"
                    type="button"
                  >
                     {{$t('passed')}}
                  </button>
                  <button
                    @click.stop="refuseClick(item.id)"
                    style="margin-left: 15px"
                    class="btn btn-danger"
                    type="button"
                  >
                     {{$t('reject')}}
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-pagination
      :page-size="50"
      background
      layout="pager"
      @current-change="getApproves"
      :total="totalCount"
      :current-page="currentIndex"
    >
    </el-pagination>
  </div>
</template>

<script>
import swal from "sweetalert2";
import {
  GetApproves,
  GetUser,
  PassApproves,
  RefuseApproves,
  GetImagePath,
} from "../common/httphelper.js";

// 对Date的扩展，将 Date 转化为指定格式的String
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

export default {
  data: function () {
    return {
      Approves: [],
      currentApprove: undefined,
      currentIndex: 1,
      totalCount: 1,
      dialogShow: false,
      users: [],
      imagePath: undefined,
      RefusedInputShow: false,
      RefusedItemId: null,
      RefusedMessage: null,
    };
  },
  methods: {
    submitClick(id) {
      PassApproves(id).then((res) => {
        if (res.data.data) {
          swal.fire({
            icon: "success",
            title: "审批通过",
            showConfirmButton: false,
            timer: 1500,
          });
          this.getApproves(this.currentIndex);
        } else {
          swal.fire({
            icon: "error",
            title: res.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
    refuseClick(id) {
      this.RefusedInputShow = true;
      this.RefusedItemId = id;
    },
    confirmRefused() {
      RefuseApproves({
        id: this.RefusedItemId,
        RefusedMessage: this.RefusedMessage,
      }).then((res) => {
        if (res.data.data) {
          swal.fire({
            icon: "success",
            iconColor: "rgba(253,84,105,0.24)",
            title: "已拒绝",
            showConfirmButton: false,
            timer: 1500,
          });
          this.getApproves(this.currentIndex);
          this.RefusedInputShow = false;
          this.RefusedMessage = null;
        } else {
          swal.fire({
            icon: "error",
            title: res.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
    async getApproves(currentIndex) {
      await GetUser().then((res) => {
        this.users = res.data;
      });

      await GetApproves(currentIndex).then((res) => {
        this.Approves = res.data.data;
        this.totalCount = res.data.count;
        this.currentIndex = currentIndex;
      });

      this.Approves.forEach((item) => {
        item.createUser = this.users.find((user) => item.createUser == user.id).realName;
        if (item.approvedUser != null)
          item.approvedUser = this.users.find(
            (user) => item.approvedUser == user.id
          ).realName;
      });
    },
    showdialog(item) {
      this.dialogShow = true;
      this.currentApprove = item;
    },
  },
  async mounted() {
    this.getApproves(1);
    await GetImagePath().then((res) => {
      this.imagePath = res.data;
    });
  },
};
</script>

<style scoped>
td {
  border: black;
  padding: 10px 20px;
}
</style>
